import type mapboxgl from 'mapbox-gl';
import { setCorrectPixelRatioToIconImages } from 'pages/timeline/timeline.functions';
import annotationImagePhoto from './markers/Annotation-photo.png?inline';
import annotationImageSimulatedPhoto from './markers/Annotation-simulated-photo.png?inline';
import annotationImageSimulated from './markers/Annotation-simulated.png?inline';
import annotationImage from './markers/Annotation.png?inline';
import customFormImage from './markers/Custom-form.png?inline';
import error from './markers/Error.png?inline';
import genericPointPinNotSelected from './markers/Generic-point-not-selected.png?inline';
import genericPointPinSelected from './markers/Generic-point.png?inline';
import monitoringImagePhoto from './markers/Monitoring-photo.png?inline';
import monitoringImageSimulatedPhoto from './markers/Monitoring-simulated-photo.png?inline';
import monitoringImageSimulated from './markers/Monitoring-simulated.png?inline';
import monitoringImage from './markers/Monitoring.png?inline';
import monitoringImageBlank from './markers/MonitoringBlank.png?inline';
import monitoringImageBlankPhoto from './markers/MonitoringBlankPhoto.png?inline';
import monitoringImageSimulatedBlank from './markers/MonitoringBlankSimulated.png?inline';
import monitoringImageMultiplePhoto from './markers/MonitoringSeverity/MonitoringImageMultiplePhoto.png?inline';
import monitoringImageSimulatedMultiplePhoto from './markers/MonitoringSeverity/MonitoringImageSimulatedMultiplePhoto.png?inline';
import monitoringNoT from './markers/MonitoringSeverity/MonitoringNo.png?inline';
import monitoringImageNoMultiplePhoto from './markers/MonitoringSeverity/MonitoringNoMultiplePhoto.png?inline';
import monitoringNoTPhoto from './markers/MonitoringSeverity/MonitoringNoPhoto.png?inline';
import monitoringNoTSimulated from './markers/MonitoringSeverity/MonitoringNoSimulated.png?inline';
import monitoringImageNoSimulatedMultiplePhoto from './markers/MonitoringSeverity/MonitoringNoSimulatedMultiplePhoto.png?inline';
import monitoringNoTSimulatedPhoto from './markers/MonitoringSeverity/MonitoringNoSimulatedPhoto.png?inline';
import monitoringT1 from './markers/MonitoringSeverity/MonitoringT1.png?inline';
import monitoringImageT1MultiplePhoto from './markers/MonitoringSeverity/MonitoringT1MultiplePhoto.png?inline';
import monitoringT1Photo from './markers/MonitoringSeverity/MonitoringT1Photo.png?inline';
import monitoringT1Simulated from './markers/MonitoringSeverity/MonitoringT1Simulated.png?inline';
import monitoringImageT1SimulatedMultiplePhoto from './markers/MonitoringSeverity/MonitoringT1SimulatedMultiplePhoto.png?inline';
import monitoringT1SimulatedPhoto from './markers/MonitoringSeverity/MonitoringT1SimulatedPhoto.png?inline';
import monitoringT2 from './markers/MonitoringSeverity/MonitoringT2.png?inline';
import monitoringImageT2MultiplePhoto from './markers/MonitoringSeverity/MonitoringT2MultiplePhoto.png?inline';
import monitoringT2Photo from './markers/MonitoringSeverity/MonitoringT2Photo.png?inline';
import monitoringT2Simulated from './markers/MonitoringSeverity/MonitoringT2Simulated.png?inline';
import monitoringImageT2SimulatedMultiplePhoto from './markers/MonitoringSeverity/MonitoringT2SimulatedMultiplePhoto.png?inline';
import monitoringT2SimulatedPhoto from './markers/MonitoringSeverity/MonitoringT2SimulatedPhoto.png?inline';
import monitoringT3 from './markers/MonitoringSeverity/MonitoringT3.png?inline';
import monitoringImageT3MultiplePhoto from './markers/MonitoringSeverity/MonitoringT3MultiplePhoto.png?inline';
import monitoringT3Photo from './markers/MonitoringSeverity/MonitoringT3Photo.png?inline';
import monitoringT3Simulated from './markers/MonitoringSeverity/MonitoringT3Simulated.png?inline';
import monitoringImageT3SimulatedMultiplePhoto from './markers/MonitoringSeverity/MonitoringT3SimulatedMultiplePhoto.png?inline';
import monitoringT3SimulatedPhoto from './markers/MonitoringSeverity/MonitoringT3SimulatedPhoto.png?inline';
import monitoringImageSimulatedBlankPhoto from './markers/MonitoringSimulatedBlankPhoto.png?inline';
import noDataImage from './markers/NoData.png?inline';
import note from './markers/notes/Note.png?inline';
import noteAudio from './markers/notes/NoteAudio.png?inline';
import notePhoto from './markers/notes/NotePhoto.png?inline';
import notePhotoAudio from './markers/notes/NotePhotoAudio.png?inline';
import noteSimulated from './markers/notes/NoteSimulated.png?inline';
import noteSimulatedAudio from './markers/notes/NoteSimulatedAudio.png?inline';
import noteSimulatedPhoto from './markers/notes/NoteSimulatedPhoto.png?inline';
import noteSimulatedPhotoAudio from './markers/notes/NoteSimulatedPhotoAudio.png?inline';
import phenologicalStateImagePhoto from './markers/Phenological-state-photo.png?inline';
import phenologicalStateImageSimulatedPhoto from './markers/Phenological-state-simulated-photo.png?inline';
import phenologicalStateImageSimulated from './markers/Phenological-state-simulated.png?inline';
import phenologicalStateImage from './markers/Phenological-state.png?inline';
import blankPin from './markers/pin.png?inline';
import propertyRegionalRisk from './markers/PropertyRegionalRisk.png?inline';
import pluviometerPinNotSelected from './markers/Rain-gauge-not-selected.png?inline';
import pluviometerPinSelected from './markers/Rain-gauge.png?inline';
import pluviometerPinSimulated from './markers/Rain-gauge-simulated.png?inline';
import {
  default as monitoringImagePhotoSampling,
  default as monitoringImageSimulatedSampling
} from './markers/Sampling/Sampling-photo.png?inline';
import monitoringImageSimulatedPhotoSampling from './markers/Sampling/Sampling-simulated.png?inline';
import monitoringImageSampling from './markers/Sampling/Sampling.png?inline';
import scoutingPlanTeamNotPriotitizedPin from './markers/ScoutingPlans/NotPrioritizedField.png?inline';
import scoutingPlanTeamPin1 from './markers/ScoutingPlans/pin1.png?inline';
import scoutingPlanTeamPin10 from './markers/ScoutingPlans/pin10.png?inline';
import scoutingPlanTeamPin11 from './markers/ScoutingPlans/pin11.png?inline';
import scoutingPlanTeamPin12 from './markers/ScoutingPlans/pin12.png?inline';
import scoutingPlanTeamPin13 from './markers/ScoutingPlans/pin13.png?inline';
import scoutingPlanTeamPin14 from './markers/ScoutingPlans/pin14.png?inline';
import scoutingPlanTeamPin15 from './markers/ScoutingPlans/pin15.png?inline';
import scoutingPlanTeamPin16 from './markers/ScoutingPlans/pin16.png?inline';
import scoutingPlanTeamPin19 from './markers/ScoutingPlans/pin17.png?inline';
import scoutingPlanTeamPin18 from './markers/ScoutingPlans/pin18.png?inline';
import scoutingPlanTeamPin17 from './markers/ScoutingPlans/pin19.png?inline';
import scoutingPlanTeamPin20 from './markers/ScoutingPlans/pin20.png?inline';
import scoutingPlanTeamPin21 from './markers/ScoutingPlans/pin21.png?inline';
import scoutingPlanTeamPin22 from './markers/ScoutingPlans/pin22.png?inline';
import scoutingPlanTeamPin23 from './markers/ScoutingPlans/pin23.png?inline';
import scoutingPlanTeamPin3 from './markers/ScoutingPlans/pin3.png?inline';
import scoutingPlanTeamPin4 from './markers/ScoutingPlans/pin4.png?inline';
import scoutingPlanTeamPin5 from './markers/ScoutingPlans/pin5.png?inline';
import scoutingPlanTeamPin6 from './markers/ScoutingPlans/pin6.png?inline';
import scoutingPlanTeamPin7 from './markers/ScoutingPlans/pin7.png?inline';
import scoutingPlanTeamPin8 from './markers/ScoutingPlans/pin8.png?inline';
import scoutingPlanTeamPin9 from './markers/ScoutingPlans/pin9.png?inline';
import trapClusterAcceptance from './markers/Trap-cluster-acceptance.png?inline';
import trapClusterControl from './markers/Trap-cluster-control.png?inline';
import trapClusterDamage from './markers/Trap-cluster-damage.png?inline';
import trapClusterNoActivity from './markers/Trap-cluster-no-activity.png?inline';
import trapCreate from './markers/Trap-create.png?inline';
import trapScoutingPlanClickedNotSelected from './markers/Trap-scouting-plan-clicked-not-selected.png?inline';
import trapScoutingPlanClickedSelected from './markers/Trap-scouting-plan-clicked-selected.png?inline';
import trapScoutingPlanNotSelected from './markers/Trap-scouting-plan-not-selected.png?inline';
import trapScoutingPlanSelected from './markers/Trap-scouting-plan-selected.png?inline';
import trapSeverityAcceptanceExpired from './markers/Trap-severity-acceptance-expired.png?inline';
import trapSeverityAcceptanceUninstalled from './markers/Trap-severity-acceptance-uninstalled.png?inline';
import trapSeverityAcceptance from './markers/Trap-severity-acceptance.png?inline';
import trapSeverityControlExpired from './markers/Trap-severity-control-expired.png?inline';
import trapSeverityControlUninstalled from './markers/Trap-severity-control-uninstalled.png?inline';
import trapSeverityControl from './markers/Trap-severity-control.png?inline';
import trapSeverityDamageExpired from './markers/Trap-severity-damage-expired.png?inline';
import trapSeverityDamageUninstalled from './markers/Trap-severity-damage-uninstalled.png?inline';
import trapSeverityDamage from './markers/Trap-severity-damage.png?inline';
import trapSeverityNoActivityExpired from './markers/Trap-severity-no-activity-expired.png?inline';
import trapSeverityNoActivityUninstalled from './markers/Trap-severity-no-activity-uninstalled.png?inline';
import trapSeverityNoActivity from './markers/Trap-severity-no-activity.png?inline';
import trapPin from './markers/Trap-pin.png?inline';
import trapPinNone from './markers/Trap-pin-none.png?inline';
import trapPinNonePhoto from './markers/Trap-pin-nonePhoto.png?inline';
import trapPinNoneSimulated from './markers/Trap-pin-noneSimulated.png?inline';
import trapPinNoneSimulatedPhoto from './markers/Trap-pin-noneSimulatedPhoto.png?inline';
import trapPinAcceptance from './markers/Trap-pin-acceptance.png?inline';
import trapPinAcceptancePhoto from './markers/Trap-pin-acceptancePhoto.png?inline';
import trapPinAcceptanceSimulated from './markers/Trap-pin-acceptanceSimulated.png?inline';
import trapPinAcceptanceSimulatedPhoto from './markers/Trap-pin-acceptanceSimulatedPhoto.png?inline';
import trapPinControl from './markers/Trap-pin-control.png?inline';
import trapPinControlPhoto from './markers/Trap-pin-controlPhoto.png?inline';
import trapPinControlSimulated from './markers/Trap-pin-controlSimulated.png?inline';
import trapPinControlSimulatedPhoto from './markers/Trap-pin-controlSimulatedPhoto.png?inline';
import trapPinDamage from './markers/Trap-pin-damage.png?inline';
import trapPinDamagePhoto from './markers/Trap-pin-damagePhoto.png?inline';
import trapPinDamageSimulated from './markers/Trap-pin-damageSimulated.png?inline';
import trapPinDamageSimulatedPhoto from './markers/Trap-pin-damageSimulatedPhoto.png?inline';
import trapPinPhoto from './markers/Trap-pin-photo.png?inline';
import trapPinSimulated from './markers/Trap-pin-simulated.png?inline';
import trapPinSimulatedPhoto from './markers/Trap-pin-simulated-photo.png?inline';

interface MapMarkerImage {
  id: string;
  url: string;
}

const mapMarkerImagesOld: MapMarkerImage[] = [
  { id: 'customFormImage', url: customFormImage },
  {
    id: 'monitoringImage',
    url: monitoringImage
  },
  {
    id: 'monitoringImageSimulated',
    url: monitoringImageSimulated
  },
  {
    id: 'phenologicalStateImage',
    url: phenologicalStateImage
  },
  {
    id: 'phenologicalStateImageSimulated',
    url: phenologicalStateImageSimulated
  },
  {
    id: 'annotationImage',
    url: annotationImage
  },
  {
    id: 'annotationImageSimulated',
    url: annotationImageSimulated
  },
  {
    id: 'annotationImageSimulatedPhoto',
    url: annotationImageSimulatedPhoto
  },
  {
    id: 'annotationImagePhoto',
    url: annotationImagePhoto
  },
  {
    id: 'monitoringImageSimulatedPhoto',
    url: monitoringImageSimulatedPhoto
  },
  {
    id: 'monitoringImagePhoto',
    url: monitoringImagePhoto
  },
  {
    id: 'phenologicalStateImageSimulatedPhoto',
    url: phenologicalStateImageSimulatedPhoto
  },
  {
    id: 'phenologicalStateImagePhoto',
    url: phenologicalStateImagePhoto
  },
  {
    id: 'noDataImage',
    url: noDataImage
  },
  {
    id: 'errorImage',
    url: error
  },
  {
    id: 'blankPin',
    url: blankPin
  },
  {
    id: 'trapClusterControl',
    url: trapClusterControl
  },
  {
    id: 'trapClusterAcceptance',
    url: trapClusterAcceptance
  },
  {
    id: 'trapClusterDamage',
    url: trapClusterDamage
  },
  {
    id: 'trapClusterNoActivity',
    url: trapClusterNoActivity
  },
  {
    id: 'trapSeverityControl',
    url: trapSeverityControl
  },
  {
    id: 'trapSeverityAcceptance',
    url: trapSeverityAcceptance
  },
  {
    id: 'trapSeverityDamage',
    url: trapSeverityDamage
  },
  {
    id: 'trapSeverityNoActivity',
    url: trapSeverityNoActivity
  },
  {
    id: 'trapSeverityControlExpired',
    url: trapSeverityControlExpired
  },
  {
    id: 'trapSeverityAcceptanceExpired',
    url: trapSeverityAcceptanceExpired
  },
  {
    id: 'trapSeverityDamageExpired',
    url: trapSeverityDamageExpired
  },
  {
    id: 'trapSeverityNoActivityUninstalled',
    url: trapSeverityNoActivityUninstalled
  },
  {
    id: 'trapSeverityControlUninstalled',
    url: trapSeverityControlUninstalled
  },
  {
    id: 'trapSeverityAcceptanceUninstalled',
    url: trapSeverityAcceptanceUninstalled
  },
  {
    id: 'trapSeverityDamageUninstalled',
    url: trapSeverityDamageUninstalled
  },
  {
    id: 'trapSeverityNoActivityExpired',
    url: trapSeverityNoActivityExpired
  },
  {
    id: 'trapCreate',
    url: trapCreate
  }
];

export const mapMarkerImages: MapMarkerImage[] = [
  {
    id: 'trapPin',
    url: trapPin
  },
  { id: 'trapPinNone', url: trapPinNone },
  { id: 'trapPinNonePhoto', url: trapPinNonePhoto },
  { id: 'trapPinNoneSimulated', url: trapPinNoneSimulated },
  { id: 'trapPinNoneSimulatedPhoto', url: trapPinNoneSimulatedPhoto },
  {
    id: 'trapPinPhoto',
    url: trapPinPhoto
  },
  {
    id: 'trapPinSimulated',
    url: trapPinSimulated
  },
  {
    id: 'trapPinSimulatedPhoto',
    url: trapPinSimulatedPhoto
  },
  {
    id: 'trapPinDamage',
    url: trapPinDamage
  },
  {
    id: 'trapPinDamagePhoto',
    url: trapPinDamagePhoto
  },
  {
    id: 'trapPinDamageSimulated',
    url: trapPinDamageSimulated
  },
  {
    id: 'trapPinDamageSimulatedPhoto',
    url: trapPinDamageSimulatedPhoto
  },
  {
    id: 'trapPinControl',
    url: trapPinControl
  },
  {
    id: 'trapPinControlPhoto',
    url: trapPinControlPhoto
  },
  {
    id: 'trapPinControlSimulated',
    url: trapPinControlSimulated
  },
  {
    id: 'trapPinControlSimulatedPhoto',
    url: trapPinControlSimulatedPhoto
  },
  {
    id: 'trapPinAcceptance',
    url: trapPinAcceptance
  },
  {
    id: 'trapPinAcceptancePhoto',
    url: trapPinAcceptancePhoto
  },
  {
    id: 'trapPinAcceptanceSimulated',
    url: trapPinAcceptanceSimulated
  },
  {
    id: 'trapPinAcceptanceSimulatedPhoto',
    url: trapPinAcceptanceSimulatedPhoto
  },
  {
    id: 'monitoringImageSampling',
    url: monitoringImageSampling
  },
  {
    id: 'propertyRegionalRisk',
    url: propertyRegionalRisk
  },
  {
    id: 'monitoringImageSimulatedSampling',
    url: monitoringImageSimulatedSampling
  },
  {
    id: 'monitoringImageSimulatedPhotoSampling',
    url: monitoringImageSimulatedPhotoSampling
  },
  {
    id: 'monitoringImagePhotoSampling',
    url: monitoringImagePhotoSampling
  },
  {
    id: 'monitoringImage',
    url: monitoringImageBlank
  },
  {
    id: 'monitoringImageSimulated',
    url: monitoringImageSimulatedBlank
  },
  {
    id: 'monitoringImageSimulatedPhoto',
    url: monitoringImageSimulatedBlankPhoto
  },
  {
    id: 'monitoringImagePhoto',
    url: monitoringImageBlankPhoto
  },
  // Severity
  {
    id: 'monitoringImageNo',
    url: monitoringNoT
  },
  {
    id: 'monitoringImageT1',
    url: monitoringT1
  },
  {
    id: 'monitoringImageT2',
    url: monitoringT2
  },
  {
    id: 'monitoringImageT3',
    url: monitoringT3
  },
  {
    id: 'monitoringImageNoPhoto',
    url: monitoringNoTPhoto
  },
  {
    id: 'monitoringImageNoMultiplePhoto',
    url: monitoringImageNoMultiplePhoto
  },
  {
    id: 'monitoringImageNoSimulatedMultiplePhoto',
    url: monitoringImageNoSimulatedMultiplePhoto
  },
  {
    id: 'monitoringImageT3MultiplePhoto',
    url: monitoringImageT3MultiplePhoto
  },
  {
    id: 'monitoringImageT3SimulatedMultiplePhoto',
    url: monitoringImageT3SimulatedMultiplePhoto
  },
  {
    id: 'monitoringImageT2MultiplePhoto',
    url: monitoringImageT2MultiplePhoto
  },
  {
    id: 'monitoringImageT2SimulatedMultiplePhoto',
    url: monitoringImageT2SimulatedMultiplePhoto
  },
  {
    id: 'monitoringImageT1MultiplePhoto',
    url: monitoringImageT1MultiplePhoto
  },
  {
    id: 'monitoringImageT1SimulatedMultiplePhoto',
    url: monitoringImageT1SimulatedMultiplePhoto
  },
  {
    id: 'monitoringImageSimulatedMultiplePhoto',
    url: monitoringImageSimulatedMultiplePhoto
  },
  {
    id: 'monitoringImageMultiplePhoto',
    url: monitoringImageMultiplePhoto
  },
  {
    id: 'monitoringImageT1Photo',
    url: monitoringT1Photo
  },
  {
    id: 'monitoringImageT2Photo',
    url: monitoringT2Photo
  },
  {
    id: 'monitoringImageT3Photo',
    url: monitoringT3Photo
  },
  {
    id: 'monitoringImageNoSimulated',
    url: monitoringNoTSimulated
  },
  {
    id: 'monitoringImageT1Simulated',
    url: monitoringT1Simulated
  },
  {
    id: 'monitoringImageT2Simulated',
    url: monitoringT2Simulated
  },
  {
    id: 'monitoringImageT3Simulated',
    url: monitoringT3Simulated
  },
  {
    id: 'monitoringImageNoSimulatedPhoto',
    url: monitoringNoTSimulatedPhoto
  },
  {
    id: 'monitoringImageT1SimulatedPhoto',
    url: monitoringT1SimulatedPhoto
  },
  {
    id: 'monitoringImageT2SimulatedPhoto',
    url: monitoringT2SimulatedPhoto
  },
  {
    id: 'monitoringImageT3SimulatedPhoto',
    url: monitoringT3SimulatedPhoto
  },
  {
    id: 'trapScoutingPlanSelected',
    url: trapScoutingPlanSelected
  },
  {
    id: 'trapScoutingPlanNotSelected',
    url: trapScoutingPlanNotSelected
  },
  {
    id: 'trapScoutingPlanClickedSelected',
    url: trapScoutingPlanClickedSelected
  },
  {
    id: 'trapScoutingPlanClickedNotSelected',
    url: trapScoutingPlanClickedNotSelected
  },
  {
    id: 'pluviometerPinSelected',
    url: pluviometerPinSelected
  },
  {
    id: 'pluviometerPinSimulated',
    url: pluviometerPinSimulated
  },
  {
    id: 'pluviometerPinNotSelected',
    url: pluviometerPinNotSelected
  },
  {
    id: 'genericPointPinSelected',
    url: genericPointPinSelected
  },
  {
    id: 'genericPointPinNotSelected',
    url: genericPointPinNotSelected
  },
  {
    id: 'note',
    url: note
  },
  {
    id: 'notePhoto',
    url: notePhoto
  },
  {
    id: 'noteAudio',
    url: noteAudio
  },
  {
    id: 'notePhotoAudio',
    url: notePhotoAudio
  },
  {
    id: 'noteSimulated',
    url: noteSimulated
  },
  {
    id: 'noteSimulatedPhoto',
    url: noteSimulatedPhoto
  },
  {
    id: 'noteSimulatedAudio',
    url: noteSimulatedAudio
  },
  {
    id: 'noteSimulatedPhotoAudio',
    url: noteSimulatedPhotoAudio
  },
  {
    id: 'scoutingPlanTeamPin#0071CD',
    url: scoutingPlanTeamPin1
  },
  {
    id: 'scoutingPlanTeamPin#2B9C92',
    url: scoutingPlanTeamPin3
  },
  {
    id: 'scoutingPlanTeamPin#2E1954',
    url: scoutingPlanTeamPin4
  },
  {
    id: 'scoutingPlanTeamPin#5EBB7F',
    url: scoutingPlanTeamPin5
  },
  {
    id: 'scoutingPlanTeamPin#5FD2C8',
    url: scoutingPlanTeamPin6
  },
  {
    id: 'scoutingPlanTeamPin#9A6412',
    url: scoutingPlanTeamPin7
  },
  {
    id: 'scoutingPlanTeamPin#9C2628',
    url: scoutingPlanTeamPin8
  },
  {
    id: 'scoutingPlanTeamPin#9664F0',
    url: scoutingPlanTeamPin9
  },
  {
    id: 'scoutingPlanTeamPin#165C56',
    url: scoutingPlanTeamPin10
  },
  {
    id: 'scoutingPlanTeamPin#643AAA',
    url: scoutingPlanTeamPin11
  },
  {
    id: 'scoutingPlanTeamPin#0C612C',
    url: scoutingPlanTeamPin12
  },
  {
    id: 'scoutingPlanTeamPin#9664F0',
    url: scoutingPlanTeamPin13
  },
  {
    id: 'scoutingPlanTeamPin#523305',
    url: scoutingPlanTeamPin14
  },
  {
    id: 'scoutingPlanTeamPin#A9EFE8',
    url: scoutingPlanTeamPin15
  },
  {
    id: 'scoutingPlanTeamPin#BB485D',
    url: scoutingPlanTeamPin16
  },
  {
    id: 'scoutingPlanTeamPin#C6E6FF',
    url: scoutingPlanTeamPin17
  },
  {
    id: 'scoutingPlanTeamPin#C17E19',
    url: scoutingPlanTeamPin18
  },
  {
    id: 'scoutingPlanTeamPin#C1462B',
    url: scoutingPlanTeamPin19
  },
  {
    id: 'scoutingPlanTeamPin#D2BDF9',
    url: scoutingPlanTeamPin20
  },
  {
    id: 'scoutingPlanTeamPin#F0C355',
    url: scoutingPlanTeamPin21
  },
  {
    id: 'scoutingPlanTeamPin#FF785A',
    url: scoutingPlanTeamPin22
  },
  {
    id: 'scoutingPlanTeamPin#FFB2C1',
    url: scoutingPlanTeamPin23
  },
  {
    id: 'scoutingPlanTeamNotPriotitizedPin',
    url: scoutingPlanTeamNotPriotitizedPin
  },
  ...mapMarkerImagesOld
];

export function addImagesToMap(map: mapboxgl.Map, images: MapMarkerImage[]): void {
  images.forEach(image => {
    map.loadImage(image.url, (err, img) => {
      if (err) {
        return;
      }
      if (!map.hasImage(image.id)) {
        const pixelRatio = setCorrectPixelRatioToIconImages(image);
        map.addImage(image.id, img as HTMLImageElement, { pixelRatio });
      }
    });
  });
}

export const addMissingImageToMap = (map: mapboxgl.Map, imageId: string): void => {
  const missingImage = mapMarkerImages.find(image => image.id === imageId);
  if (missingImage) addImagesToMap(map, [missingImage]);
};
